<template>
    <div class="c-home u-overflow-h u-fit-w" v-bind:class="{ 'is-page-ready': pageIsReady }">
        <section class="js-section u-relative">
            <my-scene class="c-scene u-relative"></my-scene>
            <section class="u-absolute u-pos-tl u-viewport-fit-h u-fit-w | u-fit@sm">
                <header class="c-header u-absolute u-offset-l-w1of16 u-color--white u-force-3d">
                    <p class="t-text t-text--sm u-medium">Florent Biffi</p>
                    <p class="t-text t-text--sm u-medium">91 — 19</p>
                </header>
                <button v-on:click="onScroll" class="c-arrow t-btn u-absolute u-pos-br u-offset-r-w1of16">
                    <div class="c-arrow-inner u-absolute u-pos-tl"></div>
                </button>
            </section>
        </section>

        <section class="js-section c-works">
            <appear-object>
                <h2 class="c-title t-text--xs u-uppercase">Recent works</h2>
            </appear-object>
            <ul class="t-list u-pad-l-0">
                <li v-for="(item, index) in works" v-bind:key="index" ref="items">
                    <appear-object>
                        <template v-if="item.video">
                            <button v-on:click="openVideo(index)" v-bind:class="{ 'is-active': index === currentIndexProject && videoActive }" class="js-item c-works-item t-btn t-h2 u-uppercase u-fit-w">
                                <span class="c-works-item-label" v-bind:data-text="item.title">{{ item.title }}</span>
                                <span class="c-works-item-line"></span>
                            </button>
                        </template>
                        <!-- <template v-else >
                            <a v-bind:href="item.url" target="_blank" class="c-works-item t-link t-h2 u-uppercase">
                                <span class="c-works-item-label" v-bind:data-text="item.title">{{ item.title }}</span>
                                <span class="c-works-item-line"></span>
                            </a>
                        </template> -->
                    </appear-object>
                </li>
                <li>
                    <appear-object>
                        <a href="https://kenzo.com" target="_blank" class="c-works-item u-block t-link t-h2 u-uppercase">
                            <span class="c-works-item-label" data-text="Kenzo">Kenzo</span>
                            <span class="c-works-item-line"></span>
                        </a>
                    </appear-object>
                </li>
                <li>
                    <appear-object>
                        <a href="http://auto.ferrari.com" target="_blank" class="c-works-item u-block t-link t-h2 u-uppercase">
                            <span class="c-works-item-label" data-text="Ferrari">Ferrari</span>
                            <span class="c-works-item-line"></span>
                        </a>
                    </appear-object>
                </li>
            </ul>
        </section>

        <section class="js-section c-about u-relative u-bg--white u-flex u-flex-flow-row-wrap">
            <appear-object>
                <h2 class="c-title c-title--about t-text--xs u-uppercase u-color--brand">About me</h2>
            </appear-object>
            <div class="u-w5of16 u-offset-l-w2of16 | u-w12of16@sm">
                <appear-object>
                    <h3 class="c-about-line t-h3 c-about-title u-color--brand">I’m a french freelance Interactive Developer, currently living in Paris. Before working as independent, I have partnered with great digital agencies such as Immersive Garden and Bigyouth.</h3>
                </appear-object>
                <appear-object>
                    <p class="c-about-line t-text--lg u-marg-t-lg">Autodidact developer, I studied graphic design at school during 3 years before making the switch. To this day, I still design personal projects as well as the occasional client work. This atypical background allows me to be very sensitive to visual details, animation or typography.</p>
                </appear-object>
                <appear-object>
                    <p class="c-about-line t-text--lg u-marg-t-md">When I am not working, I love to try gastronomic restaurants with my friends, discover cities on my bike and, foremost, lose myself in the Internet.</p>
                </appear-object>
            </div>
            <div class="c-about-right u-w8of16 u-offset-l-w1of16  | u-w12of16@sm u-offset-l-w2of16@sm">
                <div class="c-about-right-img u-block u-fit-w u-overflow-h">
                    <parallax-object v-bind:ratio="0.1" class="u-absolute u-pos-tl u-fit">
                        <img src="/static/images/florent-biffi.jpg" alt="" class="u-absolute u-pos-tl u-fit">
                    </parallax-object>
                </div>
                <appear-object>
                    <div class="c-about-line u-w5of8 u-pad-t-lg  | u-w8of8@sm">
                        <p class="t-text--lg">My clients include Ferrari, Kenzo, Samsung, Moët & Chandon, Audemars Piguet, Pernod Ricard, Mitsubishi, Air France, Lipault, Thierry Mugler, Kinder, Kronenbourg, Sociéte Générale, Pierre Fabre and many more...</p>
                        <p class="t-text--lg u-marg-t-md">Also I judge on <a href="https://thefwa.com/" target="_blank" class="t-link--primary">FWA</a>.</p>
                    </div>
                </appear-object>
            </div>
        </section>

        <section class="js-section c-awards">
            <div class="u-w12of16 u-offset-l-w2of16">
                <appear-object>
                    <h2 class="c-awards-title t-h1 u-color--white">awards &<br>recognitions</h2>
                </appear-object>

                <appear-object-table class="c-awards-table t-text u-fit-w u-marg-t-xl | u-marg-t-lg@sm">
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm">Awwwards<sup>(x16)</sup></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm u-marg-t-md@sm">Flavinsky</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Developer Award</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm "></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Flavinsky</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm "></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Oui Will</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Oui Will</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Developer Award</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm "></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Questions in the sky</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Questions in the sky</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Developer Award</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Kinder l’Oeufkicetou</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Kinder l’Oeufkicetou</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Developer Award</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Yard Agency</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Air France Music</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Bouguessa</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Reputation Squad</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Sevenhills</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Le Dernier Gaulois</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Le Dernier Gaulois</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site Of The Month </td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Acme Experience</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                </appear-object-table>

                <appear-object-table class="c-awards-table t-text u-fit-w u-marg-t-xl">
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm ">FWA<sup>(x12)</sup></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Oui Will</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm "></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm u-marg-t-md@sm">Questions in the sky</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm "></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Kinder l’Oeufkicetou</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Yard Agency</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Unsilenced </td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Reputation Squad</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Reputation Squad</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Adobe's Cutting Edge Award</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Sevenhills</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Le Dernier Gaulois</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Adobe's Cutting Edge Award</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Le Dernier Gaulois</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Mobile Of The Day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Le Dernier Gaulois</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Acme Experience</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Site of the day</td>
                    </tr>
                </appear-object-table>

                <appear-object-table class="c-awards-table t-text u-fit-w u-marg-t-xl">
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm ">Cannes Lions</td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm u-marg-t-md@sm">Unsilenced</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Bronze Lion: Direct Lions</td>
                    </tr>
                </appear-object-table>

                <appear-object-table class="c-awards-table t-text u-fit-w u-marg-t-xl">
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm ">The Lovies Awards</td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm u-marg-t-md@sm">Le Dernier Gaulois</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Bronze Winner : Best navigation</td>
                    </tr>
                    <tr class="c-awards-table-line | u-marg-t-md@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-hide@sm"></td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Acme Experience</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Silver Winner: Television</td>
                    </tr>
                </appear-object-table>
                <appear-object-table class="c-awards-table t-text u-fit-w u-marg-t-xl">
                    <tr class="c-awards-table-line | u-marg-t-sm@sm u-block@sm">
                        <td class="u-w3of12 t-text--xl u-font-bold u-color--white | u-w12of12@sm u-block@sm ">The Webby Awards</td>
                        <td class="u-w4of12 u-color--white t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm u-marg-t-md@sm">Acme Experience</td>
                        <td class="u-w5of12 t-text--lg u-text-right | u-w12of12@sm u-block@sm u-text-left@sm">Honoree : Best Visual Design - Function</td>
                    </tr>
                </appear-object-table>
            </div>
        </section>

        <appear-object class="js-section u-relative u-bg--white">
            <div class="c-contact u-w12of16 u-offset-l-w2of16 u-flex u-flex-flow-row-wrap u-justify-content-c@sm">
                <div class="c-contact-emoji">👋</div>
                <h3 class="t-h3 u-w6of12 u-marg-l-md | u-w12of12@sm u-marg-t-md@sm u-marg-l-0@sm u-text-center@sm">I’m available for freelance work, please contact me <a href="mailto:hello@florentbiffi.com" class="t-link--primary t-link--primary--bold">here</a>.</h3>
            </div>
            <div class="c-footer u-w12of16 u-offset-l-w2of16 u-flex u-flex-flow-row-wrap">
                <div class="u-w1of2 t-text--xs | u-w2of2@sm u-text-center@sm">All rights reserved — © Florent Biffi</div>
                <div class="u-w1of2 | u-w2of2@sm u-marg-t-sm@sm">
                    <ul class="t-list u-pad-l-0 u-flex u-justify-content-fe | u-justify-content-c@sm">
                        <li><a href="https://twitter.com/FlorentBiffi" target="_blank" class="t-text--xs t-link--primary">Twitter</a></li>
                        <li class="t-text--xs u-marg-x-xs">-</li>
                        <li><a href="https://www.linkedin.com/in/florent-biffi/" target="_blank" class="t-text--xs t-link--primary">Linkedin</a></li>
                        <li class="t-text--xs u-marg-x-xs">-</li>
                        <li><a href="https://www.instagram.com/florentbiffi/" target="_blank" class="t-text--xs t-link--primary">Instagram</a></li>
                    </ul>
                </div>
            </div>
        </appear-object>

        <video-project v-bind:active="videoActive" v-bind:project="currentProject" v-bind:close-video="closeVideo" v-bind:prev-video="prevVideo" v-bind:next-video="nextVideo"></video-project>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { disableScroll, enableScroll } from '@/utilities/disableScroll';
    import getOffsetTop from '@/utilities/getOffsetTop';

    import myScene from '@/components/myScene';
    import appearObject from '@/components/appearObject';
    import appearObjectTable from '@/components/appearObjectTable';
    import parallaxObject from '@/components/parallaxObject';
    import videoProject from '@/components/videoProject';
    import cursorFollow from '@/components/cursorFollow';

    export default {
        name: 'Home',

        components: {
            myScene,
            appearObject,
            parallaxObject,
            appearObjectTable,
            videoProject,
            cursorFollow,
        },

        data() {
            return {
                pageIsReady: false,
                videoActive: false,
                currentIndexProject: null,
                works: [
                    {
                        title: 'Flavinsky',
                        url: 'http://flavinsky.com/',
                        video: '/static/videos/flavinsky.mp4',
                        poster: '/static/images/poster/flavinsky.jpg',
                        credits: [
                            {
                                url: 'http://flavinsky.com/',
                                name: 'Flavien Guilbaud',
                            }
                        ],
                        colors: [
                            {
                                value: '#1A1A1A',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Oui Will',
                        url: 'https://www.ouiwill.com/',
                        video: '/static/videos/ouiwill.mp4',
                        poster: '/static/images/poster/ouwill.jpg',
                        credits: [
                            {
                                url: 'https://www.ouiwill.com/',
                                name: 'Oui Will',
                            },
                            {
                                url: 'http://flavinsky.com/',
                                name: 'Flavien Guilbaud',
                            }
                        ],
                        colors: [
                            {
                                value: '#1A1A1A',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Questions in the sky',
                        url: 'https://questionsinthesky.airfrance.com/',
                        video: '/static/videos/airfrance.mp4',
                        poster: '/static/images/poster/airfrance.jpg',
                        credits: [
                            {
                                url: 'http://betcdigital.studio/',
                                name: 'BETC Digital Studio',
                            },
                            {
                                url: 'http://damienmortini.com/',
                                name: 'Damien Mortini',
                            }
                        ],
                        colors: [
                            {
                                value: '#d4eef3',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Yard Agency',
                        url: 'https://yard.agency/',
                        video: '/static/videos/yard.mp4',
                        poster: '/static/images/poster/yard.jpg',
                        credits: [
                            {
                                url: 'https://sidlee.com/',
                                name: 'Sid Lee',
                            },
                            {
                                url: 'http://www.clementcassajus.com/',
                                name: 'Clement Cassajus',
                            }
                        ],
                        colors: [
                            {
                                value: '#1A1A1A',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    // {
                    //     title: 'Mitsubishi Outlander',
                    //     url: '#',
                    //     video: '',
                    // },
                    {
                        title: 'Unsilenced',
                        url: 'https://unsilenced.fr/',
                        video: '/static/videos/unsilenced.mp4',
                        poster: '/static/images/poster/unsilenced.jpg',
                        credits: [
                            {
                                url: 'https://betc.com/',
                                name: 'BETC',
                            },
                            {
                                url: 'http://damienmortini.com/',
                                name: 'Damien Mortini',
                            }
                        ],
                        colors: [
                            {
                                value: '#1A1A1A',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Kinder l’Oeufkicetou',
                        url: 'https://www.oeufkicetou.fr/',
                        video: '/static/videos/kinder.mp4',
                        poster: '/static/images/poster/kinder.jpg',
                        credits: [
                            {
                                url: 'https://betc.com/',
                                name: 'BETC',
                            },
                            {
                                url: 'http://damienmortini.com/',
                                name: 'Damien Mortini',
                            }
                        ],
                        colors: [
                            {
                                value: '#ADA3A2',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                            {
                                value: '#71888F',
                                timing: 23166,
                                duration: 800,
                                opacity: 0,
                            },
                        ],
                    },
                    {
                        title: 'General Pop',
                        url: 'https://itunes.apple.com/fr/app/general-pop/id1365028542',
                        video: '/static/videos/generalpop.mp4',
                        poster: '/static/images/poster/generalpop.jpg',
                        credits: [
                            {
                                url: 'https://betc.com/',
                                name: 'BETC',
                            }
                        ],
                        colors: [
                            {
                                value: '#99120C',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Adova group',
                        url: 'http://adova-group.com/',
                        video: '/static/videos/adova.mp4',
                        poster: '/static/images/poster/adova.jpg',
                        credits: [
                            {
                                url: 'https://sidlee.com/',
                                name: 'Sid Lee',
                            },
                            {
                                url: 'http://damienmortini.com/',
                                name: 'Damien Mortini',
                            },
                            {
                                url: 'http://mathieuboulet.com/',
                                name: 'Mathieu Boulet',
                            }
                        ],
                        colors: [
                            {
                                value: '#101317',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                            {
                                value: '#393F59',
                                timing: 900,
                                duration: 400,
                                opacity: 0,
                            },
                            {
                                value: '#40283C',
                                timing: 7133,
                                duration: 900,
                                opacity: 0,
                            },
                            {
                                value: '#591023',
                                timing: 8066,
                                duration: 2834,
                                opacity: 0,
                            },
                            {
                                value: '#0C234D',
                                timing: 10900,
                                duration: 4166,
                                opacity: 0,
                            },
                            {
                                value: '#1A1A1A',
                                timing: 16533,
                                duration: 497,
                                opacity: 0,
                            },
                            {
                                value: '#3B2E4D',
                                timing: 19800,
                                duration: 4990,
                                opacity: 0,
                            },
                            {
                                value: '#1F4061',
                                timing: 27003,
                                duration: 2010,
                                opacity: 0,
                            },
                        ],
                    },
                    {
                        title: 'Air France Music',
                        url: 'https://music.airfrance.com/',
                        video: '/static/videos/airfrancemusic.mp4',
                        poster: '/static/images/poster/airfrancemusic.jpg',
                        credits: [
                            {
                                url: 'https://betc.com/',
                                name: 'BETC',
                            },
                            {
                                url: 'http://samsy.ninja/',
                                name: 'Samsy',
                            }
                        ],
                        colors: [
                            {
                                value: '#807A75',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                            {
                                value: '#59241C',
                                timing: 3366,
                                duration: 800,
                                opacity: 0,
                            },
                            {
                                value: '#3A5E66',
                                timing: 13900,
                                duration: 800,
                                opacity: 0,
                            },
                            {
                                value: '#07204D',
                                timing: 37500,
                                duration: 866,
                                opacity: 0,
                            },
                            {
                                value: '#662A20',
                                timing: 47200,
                                duration: 933,
                                opacity: 0,
                            },
                        ],
                    },
                    {
                        title: 'Societe Generale',
                        url: 'https://thefutureisyou.societegenerale.com/',
                        video: '/static/videos/soge.mp4',
                        poster: '/static/images/poster/soge.jpg',
                        credits: [
                            {
                                url: 'http://betcdigital.studio/',
                                name: 'BETC Digital Studio',
                            },
                        ],
                        colors: [
                            {
                                value: '#1A1A1A',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Samsung Galaxy A',
                        url: null,
                        video: '/static/videos/samsung.mp4',
                        poster: '/static/images/poster/samsung.jpg',
                        credits: [
                            {
                                url: 'https://sidlee.com/',
                                name: 'Sid Lee',
                            },
                            {
                                url: 'http://mathieuboulet.com/',
                                name: 'Mathieu Boulet',
                            }
                        ],
                        colors: [
                            {
                                value: '#070717',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Milk Moments',
                        url: null,
                        video: '/static/videos/milkmoments.mp4',
                        poster: '/static/images/poster/milkmoments.jpg',
                        credits: [
                            {
                                url: 'https://sidlee.com/',
                                name: 'Sid Lee',
                            },
                            {
                                url: 'http://mathieuboulet.com/',
                                name: 'Mathieu Boulet',
                            }
                        ],
                        colors: [
                            {
                                value: '#205080',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Bouguessa',
                        url: 'https://bouguessa.com/',
                        video: '/static/videos/bouguessa.mp4',
                        poster: '/static/images/poster/bouguessa.jpg',
                        credits: [
                            {
                                url: 'https://www.dogstudio.co/',
                                name: 'Dogstudio',
                            },
                            {
                                url: 'http://mathieuboulet.com/',
                                name: 'Mathieu Boulet',
                            }
                        ],
                        colors: [
                            {
                                value: '#1A1A1A',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Le Dernier Gaulois',
                        url: 'http://lederniergaulois.nouvelles-ecritures.francetv.fr',
                        video: '/static/videos/lederniergaulois.mp4',
                        poster: '/static/images/poster/lederniergaulois.jpg',
                        credits: [
                            {
                                url: 'https://immersive-g.com/',
                                name: 'Immersive Garden',
                            }
                        ],
                        colors: [
                            {
                                value: '#0E0B12',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                            {
                                value: '#1A0B17',
                                timing: 1833,
                                duration: 2800,
                                opacity: 0,
                            },
                            {
                                value: '#0E0B12',
                                timing: 6433,
                                duration: 1333,
                                opacity: 0,
                            },
                        ],
                    },
                    {
                        title: 'Acme Experience',
                        url: 'http://acme-experience.com',
                        video: '/static/videos/acme.mp4',
                        poster: '/static/images/poster/acme.jpg',
                        credits: [
                            {
                                url: 'https://immersive-g.com/',
                                name: 'Immersive Garden',
                            }
                        ],
                        colors: [
                            {
                                value: '#805110',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                            {
                                value: '#38444D',
                                timing: 2100,
                                duration: 866,
                                opacity: 0,
                            },
                            {
                                value: '#38444D',
                                timing: 5200,
                                duration: 1633,
                                opacity: 0,
                            },
                        ],
                    },
                    // {
                    //     title: 'Forth & Wonder',
                    //     url: 'https://forthandwonder.com.au',
                    //     video: '',
                    // },
                    {
                        title: 'Sevenhills',
                        url: 'https://www.sevenhillswholefoods.com/experience/',
                        video: '/static/videos/sevenhills.mp4',
                        poster: '/static/images/poster/sevenhills.jpg',
                        credits: [
                            {
                                url: 'https://immersive-g.com/',
                                name: 'Immersive Garden',
                            }
                        ],
                        colors: [
                            {
                                value: '#595655',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                        ],
                    },
                    {
                        title: 'Reputation Squad',
                        url: 'http://veille.reputationsquad.com',
                        video: '/static/videos/reputationsquad.mp4',
                        poster: '/static/images/poster/reputationsquad.jpg',
                        credits: [
                            {
                                url: 'https://immersive-g.com/',
                                name: 'Immersive Garden',
                            }
                        ],
                        colors: [
                            {
                                value: '#111214',
                                timing: 0,
                                duration: 0,
                                opacity: 1,
                            },
                            {
                                value: '#636363',
                                timing: 11833,
                                duration: 767,
                                opacity: 0,
                            },
                            {
                                value: '#3E591C',
                                timing: 18266,
                                duration: 867,
                                opacity: 0,
                            },
                            {
                                value: '#636363',
                                timing: 27000,
                                duration: 1066,
                                opacity: 0,
                            },
                        ],
                    },
                    // {
                    //     title: 'Kenzo',
                    //     url: 'https://kenzo.com',
                    //     video: null,
                    // },
                    // {
                    //     title: 'Ferrari',
                    //     url: 'http://auto.ferrari.com',
                    //     video: null,
                    // },
                ],
            };
        },

        computed: {
            ...mapState('window', [
                'height',
                'isTouch',
            ]),

            currentProject() {
                if(this.currentIndexProject !== null) {
                    return this.works[this.currentIndexProject];
                }

                return null
            }
        },

        watch: {
            currentIndexProject: 'onIndexChange',
        },

        mounted() {
            this.$eventHub.$on('scene:ready', this.onReady);

            this.$nextTick(() => {
                this.$eventHub.$emit('scrollSection:update');
                this.$eventHub.$emit('resize');
            });
        },

        methods: {
            onReady() {
                this.pageIsReady = true;
            },

            onScroll() {
                window.scrollTo(0, this.height);
            },

            openVideo(index) {
                this.currentIndexProject = index;
                this.videoActive = true;
                disableScroll();
            },

            closeVideo() {
                this.videoActive = false
                enableScroll();
            },

            prevVideo() {
                if (this.currentIndexProject-1 === -1) {
                    this.currentIndexProject = this.works.length-1;
                } else {
                    this.currentIndexProject--;
                }
            },

            nextVideo() {
                if (this.currentIndexProject+1 === this.works.length) {
                    this.currentIndexProject = 0;
                } else {
                    this.currentIndexProject++;
                }
            },

            onIndexChange() {
                let offsetTop = getOffsetTop(this.$refs.items[this.currentIndexProject]);
                    offsetTop -= this.height/2;
                    offsetTop += this.$refs.items[this.currentIndexProject].offsetHeight / 2;

                window.scrollTo(0, offsetTop);
            }
        },
    };
</script>

<style lang="stylus">
    @import '../styles/settings/*'

    .c-scene {
        opacity 0
        transform translateZ(0)
        transition opacity 1.2s $ease-out-quart

        .is-page-ready & {
            opacity 1
        }
    }

    .c-header {
        position absolute
        top 80px

        opacity 0
        transform translateZ(0)
        transition opacity 1.2s $ease-out-quart

        @media $breakpoints.sm {
            top 25px
        }

        .is-page-ready & {
            opacity 1
        }
    }

    .c-arrow {
        height 40px
        width 20px
        margin-bottom 80px



        opacity 0
        transform translateY(-20px) translateZ(0)
        transition opacity 1.2s $ease-out-quart, transform 1.2s $ease-out-quart

        @media $breakpoints.sm {
            margin-bottom 25px
        }

        .is-page-ready & {
            opacity 1
            transform translateY(0px) translateZ(0)
        }

        &-inner {
            height 100%
            width 2px
            left 50%

            background $colors['white'];

            transform translateX(-1px)

            &:before {
                content ""
                position absolute
                bottom 0
                left 0
                width 2px
                height 13px
                transform-origin bottom
                transform translate(-0%, -0%) rotate(45deg)
                background $colors['white'];
            }

            &:after {
                content ""
                position absolute
                bottom 0
                left 0
                width 2px
                height 13px
                transform-origin bottom
                transform translate(-0%, -0%) rotate(-45deg)
                background $colors['white'];
            }
        }

    }

    .c-title {
        position absolute
        top 15px
        left 6.25vw
        letter-spacing 1em
        transform-origin left

        font-size 10px

        opacity 0
        transform translateY(80px) rotate(-90deg) translateX(-100%) translateZ(0)
        transition opacity 0.8s $ease-out-quart, transform 1.2s $ease-out-quart

        @media $breakpoints.sm {
            display none
        }

        .is-appear & {
            opacity 1
            transform translateY(0px) rotate(-90deg) translateX(-100%) translateZ(0)
        }

        &--about {
            top 140px
        }
    }

    .c-works {
        position relative
        margin-top 100px
        margin-bottom 200px

        @media $breakpoints.sm {
            margin-top 20px
            margin-bottom 100px
        }

        &-item {
            cursor pointer
            display block
            padding-top 20px
            padding-left 12.5vw
            padding-right 12.5vw

            opacity 0
            transform translateY(80px) rotateX(20deg) rotateY(-20deg)  translateZ(0)
            transition opacity 0.8s $ease-out-quart, transform 1.2s $ease-out-quart

            .is-appear & {
                opacity 1
                transform translateY(0px) translateZ(0)
            }

            &-label {
                display table-cell
                white-space: nowrap;
                position: relative;

                &:after {
                    content attr(data-text)
                    position absolute
                    top 0
                    left 0
                    color $colors['white'];

                    opacity 0
                    transform translateZ(0)
                    transition opacity 0.8s $ease-out-quart

                    // .is-appear & {
                    //     opacity 0
                    // }
                }
            }

            &-line {
                position relative
                display table-cell
                width 100%

                &:before {
                    content ""
                    position absolute
                    top 50%
                    left 20px
                    width calc(100% - 20px);
                    margin-top -5px
                    height 10px
                    background $colors['black'];

                    opacity 0
                    transform-origin left
                    transform scaleX(0) translateZ(0)
                    transition opacity 0.8s $ease-out-quart, transform 0.8s $ease-out-quart

                    @media $breakpoints.sm {
                        height 4px
                        margin-top -2px
                    }
                }

                &:after {
                    content ""
                    position absolute
                    top 50%
                    left 20px
                    width calc(100% - 20px);
                    margin-top -5px
                    height 10px
                    background $colors['white'];

                    opacity 0
                    transform-origin left
                    transform scaleX(0) translateZ(0)
                    transition opacity 0.8s $ease-out-quart, transform 0.8s $ease-out-quart

                    @media $breakpoints.sm {
                        height 4px
                        margin-top -2px
                    }
                }
            }

            &:hover, &.is-active {
                .c-works-item-label {
                    &:after {
                        opacity 1
                    }
                }

                .c-works-item-line {
                    &:before {
                        opacity 1
                        transform scaleX(1) translateZ(0)
                    }

                    &:after {
                        opacity 1
                        transform scaleX(1) translateZ(0)
                    }
                }
            }
        }
    }

    .c-about {
        padding 140px 0

        @media $breakpoints.sm {
            padding 100px 0
        }

        &-title {
            width 150%
            position relative
            z-index 1

            @media $breakpoints.sm {
                width 100%
            }
        }

        &-right {
            position relative
            margin-top -260px

            @media $breakpoints.sm {
                margin-top 50px
            }

            &-img {
                aspect-ratio(720, 962)
                background #EBEEF2
            }
        }

        &-line {
            opacity 0
            transform translateY(40px) translateZ(0)
            transition opacity 1.2s $ease-out-quart, transform 0.8s $ease-out-quart

            // for n in (0..5) {
            //     &--{n} {
            //         transition opacity 0.8s $ease-out-quart (n * 0.1s), transform 1.2s $ease-out-quart (n * 0.1s)
            //     }
            // }

            .is-appear & {
                opacity 1
                transform translateY(0px) translateZ(0)
            }
        }
    }

    .c-awards {
        padding 200px 0

        @media $breakpoints.sm {
            padding 100px 0
        }

        &-title {
            opacity 0
            transform translateY(40px) translateZ(0)
            transition opacity 1.2s $ease-out-quart, transform 0.8s $ease-out-quart

            .is-appear & {
                opacity 1
                transform translateY(0px) translateZ(0)
            }
        }

        &-table {
            position relative
            // border-top 1px solid $colors['white'];
            padding-top 20px

            &:before {
                content ""
                position absolute
                top 0
                left 0
                width 100%
                height 1px
                background $colors['white'];

                transform-origin left
                transform scaleX(0) translateZ(0)
                transition transform 0.8s $ease-out-quart
            }

            &.is-appear {
                &:before {
                    transform scaleX(1) translateZ(0)
                }
            }

            &-line {
                height 40px

                opacity 0
                transform translateY(40px) translateZ(0)

                @media $breakpoints.sm {
                    height auto
                }

                for n in (0..20) {
                    &:nth-child({n}) {
                        transition opacity 1.2s $ease-out-quart (n * 0.1s), transform 0.8s $ease-out-quart (n * 0.1s)
                    }
                }

                .is-appear & {
                    opacity 1
                    transform translateY(0px) translateZ(0)
                }
            }
        }
    }

    .c-contact {
        padding-top 250px

        opacity 0
        transform translateY(80px) rotateX(20deg) rotateY(-20deg)  translateZ(0)
        transition opacity 1.2s $ease-out-quart, transform 1.2s $ease-out-quart

        @media $breakpoints.sm {
            padding-top 100px
        }

        .is-appear & {
            opacity 1
            transform translateY(0px) translateZ(0)
        }

        &-emoji {
            font-size: 60px;
        }
    }

    .c-footer {
        padding-top 250px
        padding-bottom 30px

        @media $breakpoints.sm {
            padding-top 100px
        }
    }
</style>